export class ClassificationModel{
  clasCode ='' ;
  clasName ='' ;
  clasNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';
}
export class CategoryModel{
  catCode ='' ;
  catName ='' ;
  catNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';
}
